// Dungeon boon effect reducer. Phase 5.x-A4 turns run-scope boons into the
// numeric modifiers already consumed by battle / reward / resolution code.
export const EMPTY_DUNGEON_BOON_EFFECTS = Object.freeze({
    weaponBaseBonus: 0,
    armorBonus: 0,
    hpMaxBonus: 0,
    critRateAdd: 0,
    critDamageAdd: 0,
    evasionAdd: 0,
    damageReduction: 0,
    elementBonus: {},
    cooldownReduction: 0,
    regenRatio: 0,
    summonPowerBonus: 0,
    placeablePowerBonus: 0,
    goldRewardBonus: 0,
    xpRewardBonus: 0,
});
function emptyEffects() {
    return {
        ...EMPTY_DUNGEON_BOON_EFFECTS,
        elementBonus: {},
    };
}
export function aggregateDungeonBoons(boons) {
    const effects = emptyEffects();
    if (boons === undefined)
        return effects;
    for (const boon of boons) {
        switch (boon.category) {
            case 'stat-percent':
                applyStatPercentBoon(effects, boon);
                break;
            case 'crit':
                applyCritBoon(effects, boon);
                break;
            case 'evasion':
                effects.evasionAdd += boon.value;
                break;
            case 'damage-reduction':
                effects.damageReduction += boon.value;
                break;
            case 'element':
                if (boon.elementTag !== undefined) {
                    effects.elementBonus[boon.elementTag] =
                        (effects.elementBonus[boon.elementTag] ?? 0) + boon.value;
                }
                break;
            case 'regen':
                effects.regenRatio += boon.value;
                break;
            case 'cooldown':
                effects.cooldownReduction += Math.abs(boon.value);
                break;
            case 'summon':
                effects.summonPowerBonus += boon.value;
                break;
            case 'placeable':
                effects.placeablePowerBonus += boon.value;
                break;
            case 'gold':
                effects.goldRewardBonus += boon.value;
                break;
            case 'xp':
                effects.xpRewardBonus += boon.value;
                break;
        }
    }
    return effects;
}
function applyStatPercentBoon(effects, boon) {
    switch (boonKeyword(boon.id)) {
        case 'attack-up':
            effects.weaponBaseBonus += boon.value;
            return;
        case 'defense-up':
            effects.armorBonus += boon.value;
            return;
        case 'hp-up':
            effects.hpMaxBonus += boon.value;
            return;
    }
}
function applyCritBoon(effects, boon) {
    switch (boonKeyword(boon.id)) {
        case 'crit-rate':
            effects.critRateAdd += boon.value;
            return;
        case 'crit-damage':
            effects.critDamageAdd += boon.value;
            return;
    }
}
function boonKeyword(id) {
    return id.replace(/^boon\./, '').replace(/\.t\d+$/, '');
}
export function hasAnyDungeonBoonEffect(effects) {
    return (effects.weaponBaseBonus !== 0 ||
        effects.armorBonus !== 0 ||
        effects.hpMaxBonus !== 0 ||
        effects.critRateAdd !== 0 ||
        effects.critDamageAdd !== 0 ||
        effects.evasionAdd !== 0 ||
        effects.damageReduction !== 0 ||
        Object.values(effects.elementBonus).some((v) => (v ?? 0) !== 0) ||
        effects.cooldownReduction !== 0 ||
        effects.regenRatio !== 0 ||
        effects.summonPowerBonus !== 0 ||
        effects.placeablePowerBonus !== 0 ||
        effects.goldRewardBonus !== 0 ||
        effects.xpRewardBonus !== 0);
}
//# sourceMappingURL=dungeon-boon-effects.js.map